import React from "react"
import ReactDOM from "react-dom"
import scriptLoader from "react-async-script-loader"

let clientId = null

// async function getClientId() {
//   try {
//     const res = await getCaptcha()
//     clientId = res.PAYPAL_SANDBOX_CLIENT_ID
//   } catch (e) {
//     console.log(e)
//   }
// }

// getClientId()

let PayPalButton = null

const CLIENT = {
  sandbox: "XXXXXX", //to be replaced by client id
  production: "xxxXXX",
}

class PaypalButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showButton: false,
    }

    window.React = React
    window.ReactDOM = ReactDOM
  }

  componentDidMount() {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props
    if (isScriptLoaded && isScriptLoadSucceed) {
      PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM })
      this.setState({ loading: false, showButton: true })
    }
  }

  componentWillReceiveProps(nextProps) {
    const { isScriptLoaded, isScriptLoadSucceed } = nextProps

    const scriptJustLoaded =
      !this.state.showButton && !this.props.isScriptLoaded && isScriptLoaded

    if (scriptJustLoaded) {
      if (isScriptLoadSucceed) {
        PayPalButton = window.paypal.Buttons.driver("react", {
          React,
          ReactDOM,
        })
        this.setState({ loading: false, showButton: true })
      }
    }
  }
  // createOrder = (data, actions) => {
  //   return actions.order.create({
  //     purchase_units: [
  //       {
  //         description: "New Order",
  //         amount: {
  //           currency_code: data.currency,
  //           value: data.total,
  //         },
  //       },
  //     ],
  //   })
  // }

  // onApprove = (data, actions) => {
  //   actions.order.capture().then(details => {
  //     const paymentData = {
  //       payerID: data.payerID,
  //       orderID: data.orderID,
  //       tranStatus: "A"
  //     }
  //     this.props.storePaypalTran(paymentData)
  //     console.log("Payment Approved: ", paymentData)
  //     this.setState({ showButton: false, paid: true })
  //   })
  // }
  // onCancel = data => {
  //   const paymentData = {
  //     payerID: "N/A",
  //     orderID: data.orderID,
  //     tranStatus: "C"
  //   }
  //   this.props.storePaypalTran(paymentData)
  //   this.props.setErrorMessage("Transaction Cancelled!")
  //   // Show a cancel page, or return to cart
  // }

  // onError = err => {
  //   this.props.setErrorMessage("An Error Occurred. Try again or contact us")
  //   // Show a cancel page, or return to cart
  // }

  render() {
    const { showButton } = this.state
    return (
      <div>
        {showButton && (
          <PayPalButton
            // createOrder={(data, actions) =>
            //   this.createOrder(this.props, actions)
            // }
            // onApprove={(data, actions) => this.onApprove(data, actions)}
            // onCancel={data => this.onCancel(data)}
            // onError={err => this.onError(err)}
          />
        )}
      </div>
    )
  }
}

export default scriptLoader(
  `https://www.paypal.com/sdk/js?client-id=${
  clientId
    ? clientId
    : "AZCAVHpJyGXo8a3B8T93CPgubI3_g8cz3DCLyRMWImr7pm0c-GcWa8ASxEU6vJ9ekNDERmC-iW6qQihk"
  }&currency=USD`
)(PaypalButton)
